// extracted by mini-css-extract-plugin
export default {"root":"AnimatedIconWithPreview-module__root","preview":"AnimatedIconWithPreview-module__preview"};